export default __webpack_public_path__ + "static/media/staking-bg-table.fb196c9c.png";